import React from 'react'
import { FView } from 'components'
import { colors } from 'styles'

const ButtonFillView = props => (
  <FView h={50} bg={props.disabled ? colors.lightGrey : colors.primary} center {...props} />
)

export default ButtonFillView
